import React from "react";

const QuestionsList = ({ answers, questions, current, setCurrent }) => {
  const [show, setShow] = React.useState(false);
  function jumpTo(index) {
    setCurrent(index);
    setShow(false);
  }

  return (
    <aside className="position-relative" style={{ zIndex: 1 }}>
      <button
        className="btn btn-sm btn-outline-primary mb-2 d-block d-lg-none"
        onClick={() => setShow(!show)}
      >
        {show ? "Hide All Questions" : "Show All Questions"}
      </button>
      <div
        style={{ height: "82vh" }}
        className={`bg-white shadow-sm border rounded p-3 position-absolute w-100 ${
          show ? "d-block" : "d-none d-lg-block"
        }`}
      >
        <h5 className="text-muted">All Questions</h5>
        <div className="list-group overflow-auto" style={{ height: "75vh" }}>
          {questions.map((q, i) => (
            <button
              key={i}
              className={`list-group-item list-group-item-action d-flex align-items-center ${
                current === i ? "active" : ""
              }`}
              onClick={() => jumpTo(i)}
            >
              <small className="fw-bold me-1">{i + 1}.</small>
              <small className="text-truncate">{q.text}</small>
              {answers[q.id] && (
                <span className="lh-1 ms-auto">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" />
                  </svg>
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default QuestionsList;
